import React from 'react';
import { TestimonialType } from 'types';
import styled from 'styled-components';
import quote from 'images/quotes.svg';
import { media, theme } from 'styles';

const Wrapper = styled.div`
  padding-top: 0;
  padding-bottom: 40px;

  ${media.tablet`
    display: flex;
    justify-content: space-between;
    padding-top: 100px;
    padding-bottom: 160px;
  `};
`;

const Quote = styled.div`
  position: relative;
  bottom: -30px;
  padding-right: ${theme.sp.m};

  ${props =>
    props.flip &&
    `
      display: none;
    `};

  ${media.tablet`
    bottom: auto;

    ${props =>
      props.flip &&
      `
      display: block;
      transform rotate(180deg);
    `}
  `};
`;

const TestimonialWrapper = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
`;

const Image = styled.div`
  display: block;
  margin-left: ${theme.sp.l};
  border-radius: 50%;
  background-image: url('${props => props.imageUrl}');
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  width: 60px;
  height: 60px;

  ${media.tablet`
    width: 100px;
    height: 100px;
  `};
`;

const TestimonialFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const TestimonialMeta = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

// prettier-ignore
const Content = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  font-style: italic;
  margin-bottom: ${theme.sp.max};
  color: ${theme.colors.royal};

  ${media.tablet`
    font-size: 36px;
    line-height: 48px;
  `};
`;

// prettier-ignore
const Name = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: ${theme.colors.navy};
  text-align: right;

  ${media.tablet`
    font-size: 24px;
    line-height: 36px;
  `};
`;

// prettier-ignore
const Position = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: ${theme.colors.grey};
  text-align: right;

  ${media.tablet`
    font-size: 24px;
    line-height: 36px;
  `};
`;

const propTypes = {
  testimonial: TestimonialType.isRequired,
};

function Testimonial({ testimonial }) {
  return (
    <Wrapper>
      <Quote>
        <img src={quote} alt="" />
      </Quote>
      <TestimonialWrapper>
        <Content>{testimonial.testimonial.text}</Content>
        <TestimonialFooter>
          <TestimonialMeta>
            <Name>{testimonial.name}</Name>
            <Position>{testimonial.position}</Position>
          </TestimonialMeta>
          {testimonial.logo && (
            <Image imageUrl={testimonial.logo.fullSize.src} />
          )}
        </TestimonialFooter>
      </TestimonialWrapper>
      <Quote flip>
        <img src={quote} alt="" />
      </Quote>
    </Wrapper>
  );
}

Testimonial.propTypes = propTypes;

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/components/Testimonial/Testimonial.jsx